import React, { FC } from "react";
import { format } from "date-fns";

interface Props {
  date: Date;
}

export const DateTimePreciseValue: FC<Props> = ({ date }) =>
  date ? (
    <>
      {format(new Date(date), "dd MMM yy")}
      <span className="p-0.5 text-gray-400">-</span>
      {format(new Date(date), "HH:mm:ss")}
    </>
  ) : (
    <span>-</span>
  );
